import { render, staticRenderFns } from "./FavoriteCoachesView.vue?vue&type=template&id=3a305c9b&scoped=true&"
import script from "./FavoriteCoachesView.vue?vue&type=script&lang=js&"
export * from "./FavoriteCoachesView.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteCoachesView.vue?vue&type=style&index=0&id=3a305c9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a305c9b",
  null
  
)

export default component.exports